import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { formatPostDate, getAllPosts } from '../../lib/blog';

export const Route = createFileRoute('/blog/')({
  component: BlogIndexPage,
});

function BlogIndexPage() {
  const posts = getAllPosts();
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="container-page max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-ink-2 transition-colors hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>

        <h1 className="mt-8 text-4xl font-semibold tracking-tight text-ink md:text-5xl">Blog</h1>
        <p className="mt-4 text-lg text-ink-2">
          Notes on building LYN Rx — what we shipped, why we made the calls we did, and what's next.
        </p>

        {posts.length === 0 ? (
          <p className="mt-12 text-base text-ink-2">No posts yet. Check back soon.</p>
        ) : (
          <ul className="mt-12 space-y-10">
            {posts.map((post) => (
              <li key={post.slug} className="border-b border-border pb-10 last:border-b-0 last:pb-0">
                <p className="text-sm text-ink-3">{formatPostDate(post.date)}</p>
                <h2 className="mt-2 text-2xl font-semibold tracking-tight text-ink">
                  <Link
                    to="/blog/$slug"
                    params={{ slug: post.slug }}
                    className="transition-colors hover:text-primary"
                  >
                    {post.title}
                  </Link>
                </h2>
                <p className="mt-3 text-base leading-relaxed text-ink-2">{post.excerpt}</p>
                <Link
                  to="/blog/$slug"
                  params={{ slug: post.slug }}
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary transition-colors hover:text-primary-dark"
                >
                  Read more
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
